import axios, { InternalAxiosRequestConfig } from "axios";
import { AppStore } from "../store";
import { removeRfToken, removeAcToken } from "../utils/local-storage";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const configAxios = (store: AppStore): void => {
  async function authHeadersReqHandler(config: InternalAxiosRequestConfig) {
    if (localStorage.getItem("ac_token")) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${localStorage.getItem(
        "ac_token"
      )}`;
    }
    return config;
  }
  axios.interceptors.request.use(authHeadersReqHandler);

  axios.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;

      if (originalConfig.url !== "/" && err.response) {
        // Invalid token
        if (err.response.status === 401) {
          removeRfToken();
          removeAcToken();
          window.location.href = "/";
        }
      }

      return Promise.reject(err);
    }
  );
};
